import type { ReportListFilter } from '../Contracts/Report'

type Item = Record<string, any>

export interface ReportOptionSource {
    /** Підпис поля фільтра */
    label: string
    /** Колекція API, з якої беруться опції */
    url: string
    /** Звуження опцій (формат buildOptionsFilters) */
    filter?: Record<string, unknown>
    /** Підпис опції */
    optionLabel: (item: Item) => string
}

const title = (item: Item): string => item['title'] || `#${item['id']}`

const userName = (item: Item): string =>
    item['fullName'] || `${item['lastName'] ?? ''} ${item['firstName'] ?? ''}`.trim() || `#${item['id']}`

const vehicleName = (item: Item): string => {
    const model = [item['brand'], item['model']].filter(Boolean).join(' ')
    return [item['registrationNumber'], model].filter(Boolean).join(' · ') || `#${item['id']}`
}

/** Статуси користувачів, за якими лишаються задачі (усі, крім видаленого) */
const USER_STATUSES = ['invited', 'active', 'inactive']

/**
 * Звідки брати опції кожного фільтра-довідника. Неактивні записи не відкидаються:
 * задачі за минулі періоди могли виконуватись з ними.
 */
export const REPORT_OPTION_SOURCES: Record<ReportListFilter, ReportOptionSource> = {
    carrier: { label: 'Перевізник', url: '/services/lists/carriers', optionLabel: title },
    driver: {
        label: 'Водій',
        url: '/services/users',
        filter: { filterRoles: { op: 'like', value: 'ROLE_DRIVER' }, status: USER_STATUSES },
        optionLabel: userName,
    },
    vehicle: { label: 'Транспортний засіб', url: '/services/vehicles', optionLabel: vehicleName },
    vehicleType: { label: 'Тип ТЗ', url: '/services/lists/vehicle-types', optionLabel: title },
    cargo: { label: 'Тип вантажу', url: '/services/lists/cargos', optionLabel: title },
    constructionObject: {
        label: "Об'єкт будівництва",
        url: '/services/lists/construction-objects',
        optionLabel: title,
    },
    loadingPoint: { label: 'Пункт навантаження', url: '/services/lists/loading-points', optionLabel: title },
    unloadingPoint: { label: 'Пункт розвантаження', url: '/services/lists/loading-points', optionLabel: title },
    typicalRoute: { label: 'Типовий маршрут', url: '/services/typical-routes', optionLabel: title },
    dispatcher: {
        label: 'Відповідальний диспетчер',
        url: '/services/users',
        // 'DISPATCHER' — і диспетчери, і старші диспетчери
        filter: { filterRoles: { op: 'like', value: 'DISPATCHER' }, status: USER_STATUSES },
        optionLabel: userName,
    },
}
